"use client"

import { QueryClientProvider } from "@tanstack/react-query"
import { DeploymentRecovery } from "@/components/deployment-recovery"
import { getQueryClient } from "@/lib/react-query"

export function ReactQueryProvider({ children }: Readonly<{ children: React.ReactNode }>) {
  const queryClient = getQueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <DeploymentRecovery />
      {children}
    </QueryClientProvider>
  )
}
